:host {
  display: block;
}

.overlay-text {
  text-decoration: none;
  display: inline-block;
  user-select: none;
  line-height: 1;
  opacity: var(--zeudy-dynamic-overlay-opacity, 1);
  font-size: var(--zeudy-dynamic-overlay-font-size, 18px);
  padding: var(--zeudy-dynamic-overlay-padding, 0.65em 0.85em);
  font-weight: var(--zeudy-dynamic-overlay-font-weight, 500);
  border-radius: var(--zeudy-dynamic-overlay-radius, 0.25em);
  background: var(--zeudy-dynamic-overlay-background, rgba(0, 0, 0, 0.8));
  color: var(--zeudy-dynamic-overlay-color, #fff);
  opacity: var(--zeudy-dynamic-overlay-opacity, 1);
  word-break: break-word;
}

a.overlay-text {
  cursor: pointer;
}
